import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/geo/cities/`;
const pathById = `${pathBase}:cityId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const cities = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  get: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
